export default __webpack_public_path__ + "static/media/twitterLogo.f6a8a6e7.png";